import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* getShippingCodeRandom({ payload: { onSuccess } }) {

  try {
    const { data } = yield call(fetch, { api: api.codes.random });

    onSuccess && onSuccess(data.result);
    yield put(actions.getShippingCodeRandomDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getShippingCodeRandomFailed,
      endpoint: api.codes.random.url
    });
  }
}

export const getShippingCodeRandomSaga = takeEvery(types.GET_SHIPPING_CODE_RANDOM_REQUEST, getShippingCodeRandom);